import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/main.css';
import 'sanitize.css';
import './styles/fonts.css';
import App from './App';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <App />
);